module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "medication-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style",
    class: {
      cardHasData: _vm.hasData
    }
  }, [(_vm.loading) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [(_vm.data.no_setting || _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [(_vm.hasMedications) ? _c('div', [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.data.message)
    }
  }), _vm._v("\n            " + _vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.hasMedications) ? _c('div', [_c('div', {
    staticClass: "card-notice-title"
  }, [_vm._v(_vm._s(_vm.$t('message.cardEmptyMedication')))]), _vm._v("\n            " + _vm._s(_vm.$t('message.cardTapPrefix')) + "\n            "), _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings_cog"
    },
    slot: "left"
  }), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1) : _vm._e()])], 1) : _c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardMedicationLastDose')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "card-large-stat"
  }, [_vm._v("\n                " + _vm._s(_vm.data.dosage) + " " + _vm._s(_vm.localizeRegime(_vm.data.unit_label)) + "\n              ")])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('message.cardMedicationLastMedication')) + "\n            ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.data.treatment_name) + "\n            ")])], 1)], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('svg', {
    staticClass: "card-left-icon",
    attrs: {
      "width": "16px",
      "height": "16px",
      "viewBox": "21 193 15 15",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "d": "M1.00081633,9.15102041 C-0.331428571,10.4832653 -0.331428571,12.6546939 1.00081633,13.9869388 C2.33306122,15.3191837 4.5044898,15.3191837 5.83673469,13.9869388 L9.9477551,9.87591837 L5.11183673,5.03673469 L1.00081633,9.15102041 L1.00081633,9.15102041 Z",
      "id": "path-1"
    }
  }), _vm._v(" "), _c('mask', {
    attrs: {
      "id": "mask-2",
      "maskContentUnits": "userSpaceOnUse",
      "maskUnits": "objectBoundingBox",
      "x": "0",
      "y": "0",
      "width": "9.94612245",
      "height": "9.94938776",
      "fill": "white"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#path-1"
    }
  })])]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Group-5",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd",
      "transform": "translate(21.000000, 193.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.15020408,1.00163265 L4.56897959,5.56979592 L9.40489796,10.4057143 L13.9828571,5.83428571 C15.3183673,4.50204082 15.3183673,2.33387755 13.9828571,1.00163265 C12.6506122,-0.333877551 10.482449,-0.333877551 9.15020408,1.00163265 Z",
      "id": "Shape",
      "fill": "#AD3463"
    }
  }), _vm._v(" "), _c('use', {
    attrs: {
      "id": "Shape",
      "stroke": "#AD3463",
      "mask": "url(#mask-2)",
      "stroke-width": "2",
      "xlink:href": "#path-1"
    }
  })])]), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.loading ? _vm.$t('message.loadingText') : _vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [(!_vm.loading) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "icon": "settings_cog",
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToSettings()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasMedications && !_vm.isOpenInput) ? _c('mu-icon-button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: (_vm.$t('message.addEntryText')),
      expression: "$t('message.addEntryText')",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "card-bar-icon",
    attrs: {
      "icon": 'add',
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasMedications && _vm.isOpenInput) ? _c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "icon": 'remove',
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openInput.apply(null, arguments)
      }
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [(_vm.hasMedications) ? _c('mu-card-text', [(!_vm.alreadyCopied) ? _c('div', {
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c('mu-raised-button', {
    attrs: {
      "disabled": !_vm.hasMedsToCopy,
      "label": _vm.$t('message.cardMedicationRepeatYesterday') + ' (' + _vm.yesterdayDosageCount + ')',
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.copyYesterdaysMedication.apply(null, arguments)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-name": "medication",
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('medication'),
      "data-vv-validate-on": "none",
      "data-vv-as": _vm.$t('cardMedication'),
      "scroller": _vm.scroller,
      "label": _vm.$t('message.cardMedicationSelect'),
      "hintText": _vm.$t('message.selectText'),
      "fullWidth": "",
      "autoWidth": ""
    },
    model: {
      value: (_vm.model.tracking_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "tracking_id", $$v)
      },
      expression: "model.tracking_id"
    }
  }, _vm._l((_vm.activeMedications), function(item, index) {
    return _c('mu-menu-item', {
      key: 'medication-' + index,
      attrs: {
        "title": item.treatment_name,
        "value": item.tracking_id
      }
    })
  }), 1), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:1|max_value:2500'),
      expression: "'required|min_value:1|max_value:2500'"
    }],
    staticClass: "bottom",
    attrs: {
      "min": "1",
      "max": "2500",
      "data-vv-name": "dosage",
      "data-vv-value-path": "inputValue",
      "data-vv-as": _vm.$t('message.cardMedicationDose'),
      "errorText": _vm.errors.first('dosage'),
      "data-vv-validate-on": "none",
      "label": _vm.$t('message.cardMedicationDose'),
      "type": "number",
      "hintText": _vm.$t('message.cardMedicationDosage'),
      "helpText": _vm.localizeRegime(_vm.activeLabel),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.dosage),
      callback: function($$v) {
        _vm.$set(_vm.model, "dosage", _vm._n($$v))
      },
      expression: "model.dosage"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f66e358","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Input/Medication/Medication.vue
// module id = 3745
// module chunks = 1